import { Svg, type SvgProps } from './Svg.tsx';

export const Mountain: React.FC<SvgProps> = (props) => (
  <Svg
    width="264"
    height="133"
    viewBox="0 0 264 133"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M206.529 54.9164C206.529 67.5532 196.285 77.7973 183.648 77.7973C171.011 77.7973 160.767 67.5532 160.767 54.9164C160.767 42.2797 171.011 32.0356 183.648 32.0356C196.285 32.0356 206.529 42.2797 206.529 54.9164Z"
      fill="#FFC14A"
    />
    <ellipse
      cx="219.708"
      cy="54.925"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(90 219.708 54.925)"
      fill="#FFC14A"
    />
    <ellipse
      cx="213.872"
      cy="74.8528"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(122.678 213.872 74.8528)"
      fill="#FFC14A"
    />
    <ellipse
      cx="198.147"
      cy="88.4977"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(155.365 198.147 88.4977)"
      fill="#FFC14A"
    />
    <ellipse
      cx="177.429"
      cy="91.44"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(-171.835 177.429 91.44)"
      fill="#FFC14A"
    />
    <ellipse
      cx="158.545"
      cy="82.7359"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(-138.957 158.545 82.7359)"
      fill="#FFC14A"
    />
    <ellipse
      cx="147.365"
      cy="65.2463"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(-106.248 147.365 65.2463)"
      fill="#FFC14A"
    />
    <ellipse
      cx="147.443"
      cy="44.3332"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(-73.3182 147.443 44.3332)"
      fill="#FFC14A"
    />
    <ellipse
      cx="158.74"
      cy="26.9448"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(-40.6266 158.74 26.9448)"
      fill="#FFC14A"
    />
    <ellipse
      cx="177.766"
      cy="18.3615"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(-7.72568 177.766 18.3615)"
      fill="#FFC14A"
    />
    <ellipse
      cx="198.332"
      cy="21.4367"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(25.0617 198.332 21.4367)"
      fill="#FFC14A"
    />
    <ellipse
      cx="214.009"
      cy="35.2127"
      rx="2.95236"
      ry="5.16663"
      transform="rotate(57.743 214.009 35.2127)"
      fill="#FFC14A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.741 86.172L4.58217 97.5087C2.07201 99.1671 0.688365 102.078 0.996674 105.051L2.6375 120.875C3.05155 124.868 6.37545 127.908 10.4011 127.975L254.988 132.022C262.39 132.144 266.06 123.035 260.6 118.092L199.496 62.7798C198.103 61.5187 196.013 61.3924 194.457 62.4755C193.118 63.4076 191.358 63.4563 189.985 62.5993L164.43 46.6481C161.809 45.0117 160.384 42.0028 160.775 38.9265L161.582 32.568C161.945 29.7108 160.742 26.893 158.433 25.1903L148.703 18.0155C147.963 17.4705 147.154 17.0699 146.311 16.8128C146.506 14.396 145.592 12.0223 143.813 10.3692L138.465 5.39919C135.253 2.41372 130.203 2.60217 127.169 5.82076L119.234 14.2379C118.519 14.9966 117.663 15.6103 116.716 16.045L93.3983 26.7436C91.8622 27.4484 90.5838 28.6167 89.7451 30.0824L81.2603 44.9098C79.8999 47.2873 77.4242 48.8187 74.6939 48.9718L67.4085 49.3804C65.6465 49.4792 63.9614 50.1555 62.6149 51.3041L21.741 86.172Z"
      fill="#F2F1F1"
    />
    <mask
      id="mask0_7331_11276"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="264"
      height="133"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.741 86.1715L4.58217 97.5082C2.07201 99.1666 0.688365 102.077 0.996674 105.051L2.6375 120.875C3.05155 124.868 6.37545 127.907 10.4011 127.974L254.988 132.021C262.39 132.144 266.06 123.034 260.6 118.091L199.496 62.7793C198.103 61.5182 196.013 61.392 194.457 62.475C193.118 63.4071 191.358 63.4558 189.985 62.5988L164.43 46.6476C161.809 45.0113 160.384 42.0024 160.775 38.9261L161.582 32.5676C161.945 29.7103 160.742 26.8925 158.433 25.1898L148.703 18.015C147.966 17.4717 147.159 17.072 146.319 16.8147L146.786 13.1315L132.656 0L118.151 15.3863L91.0353 27.8272L79.0766 48.7256L64.6914 49.5323L21.741 86.1715Z"
        fill="#F2F1F1"
      />
    </mask>
    <g mask="url(#mask0_7331_11276)">
      <path
        d="M81.085 48.6452L82.9108 45.8242C83.0951 45.5395 83.2425 45.2325 83.3493 44.9106L97.5328 2.16652C98.0756 0.530511 99.6055 -0.57373 101.329 -0.57373H164.061C166.27 -0.57373 168.061 1.21713 168.061 3.42627V41.3954C168.061 43.6046 166.27 45.3954 164.061 45.3954H147.743C146.498 45.3954 145.324 44.8157 144.567 43.8273L140.135 38.0394C138.536 35.952 135.393 35.9479 133.789 38.0312L125.602 48.6658C123.64 51.2147 119.562 49.8271 119.562 46.6103C119.562 43.4797 115.666 42.0411 113.632 44.4208L112.543 45.6943C111.785 46.5807 110.678 47.091 109.512 47.091H101.185C100.539 47.091 99.9033 47.2473 99.3312 47.5465L86.2967 54.3632C82.6532 56.2687 78.8509 52.097 81.085 48.6452Z"
        fill="white"
      />
      <path
        d="M44.6147 55.5193L33.5405 59.8221L-5.70565 80.0125C-8.37072 81.3836 -10.0459 84.1293 -10.0459 87.1263V129C-10.0459 133.418 -6.46418 137 -2.0459 137H273.942C280.713 137 284.422 129.112 280.103 123.897L251.585 89.4623C248.448 85.6741 242.668 85.5875 239.418 89.28L234.692 94.6509C231.922 97.7989 227.191 98.2736 223.85 95.7386L206.802 82.8014C202.226 79.3292 195.591 81.6671 194.203 87.2405L192.314 94.8239C191.038 99.9464 185.238 102.45 180.635 99.8661L154.492 85.1889C152.146 83.8716 149.25 85.5673 149.25 88.258C149.25 91.7704 144.67 93.1161 142.77 90.1621L130.47 71.0408C127.202 65.9603 119.698 66.1958 116.756 71.4711L115.518 73.6899C113.052 78.1096 107.154 79.1581 103.316 75.8589L82.1591 57.6704C78.6089 54.6184 73.2082 55.2537 70.4632 59.0463L65.7083 65.616C61.9279 70.839 53.6723 68.1649 53.6723 61.7173C53.6723 57.0412 48.9733 53.8258 44.6147 55.5193Z"
        fill="#499D69"
      />
    </g>
    <path
      d="M136.731 81.3774L133.059 91.5597C133.02 91.6685 133 91.7833 133 91.8989V99C133 99.5523 133.448 100 134 100H171.528C172.08 100 172.528 99.5523 172.528 99V91.8827C172.528 91.7776 172.512 91.6733 172.479 91.5734L170.177 84.4932C169.872 83.5547 168.535 83.5787 168.264 84.5276L166.544 90.546C166.254 91.5607 164.794 91.4925 164.6 90.4552L163.045 82.1494C162.863 81.1763 161.529 81.0311 161.142 81.9422L158.793 87.4688C158.415 88.3579 157.121 88.2476 156.899 87.3075L155.5 81.3793L153.886 76.6162C153.586 75.7304 152.343 75.7046 152.006 76.5773L149.426 83.2678C149.106 84.0986 147.941 84.128 147.58 83.3143L146.529 80.9518C146.177 80.1601 145.054 80.1601 144.702 80.9518L142.787 85.257C142.712 85.4271 142.685 85.6149 142.711 85.7994L143.674 92.8119C143.706 93.0448 143.654 93.2815 143.529 93.4804L143.055 94.2346C142.505 95.1091 141.151 94.6768 141.21 93.6453L141.483 88.8417C141.492 88.6961 141.468 88.5505 141.414 88.4151L138.601 81.3468C138.261 80.4917 137.043 80.5116 136.731 81.3774Z"
      fill="#237D45"
    />
    <path
      d="M214.731 86.3774L211.059 96.5597C211.02 96.6685 211 96.7833 211 96.8989V104C211 104.552 211.448 105 212 105H249.528C250.08 105 250.528 104.552 250.528 104V96.8827C250.528 96.7776 250.512 96.6733 250.479 96.5734L248.177 89.4932C247.872 88.5547 246.535 88.5787 246.264 89.5277L244.544 95.546C244.254 96.5607 242.794 96.4925 242.6 95.4552L241.045 87.1494C240.863 86.1763 239.529 86.0311 239.142 86.9422L238.568 88.2921C238.111 89.3681 236.494 88.9194 236.657 87.7616L237.447 82.1463C237.477 81.9391 237.44 81.7279 237.343 81.5425L232.085 71.5193C231.647 70.6827 230.4 70.8649 230.218 71.7919L227.167 87.4072C226.979 88.3664 225.669 88.5148 225.272 87.6217L224.529 85.9518C224.177 85.1601 223.054 85.1601 222.702 85.9518L220.787 90.257C220.712 90.4271 220.685 90.6149 220.711 90.7994L221.674 97.8119C221.706 98.0448 221.654 98.2815 221.529 98.4804L221.055 99.2346C220.505 100.109 219.151 99.6768 219.21 98.6453L219.483 93.8417C219.492 93.6961 219.468 93.5505 219.414 93.4151L216.601 86.3468C216.261 85.4917 215.043 85.5116 214.731 86.3774Z"
      fill="#237D45"
    />
    <path
      d="M181.731 86.3774L178.059 96.5597C178.02 96.6685 178 96.7833 178 96.8989V104C178 104.552 178.448 105 179 105H216.528C217.08 105 217.528 104.552 217.528 104V96.8827C217.528 96.7776 217.512 96.6733 217.479 96.5734L215.177 89.4932C214.872 88.5547 213.535 88.5787 213.264 89.5276L211.544 95.546C211.254 96.5607 209.794 96.4925 209.6 95.4552L208.045 87.1494C207.863 86.1763 206.529 86.0311 206.142 86.9422L203.793 92.4688C203.415 93.3579 202.121 93.2476 201.899 92.3075L200.5 86.3793L198.886 81.6162C198.586 80.7304 197.343 80.7046 197.006 81.5773L194.426 88.2678C194.106 89.0986 192.941 89.128 192.58 88.3143L191.529 85.9518C191.177 85.1601 190.054 85.1601 189.702 85.9518L187.787 90.257C187.712 90.4271 187.685 90.6149 187.711 90.7994L188.674 97.8119C188.706 98.0448 188.654 98.2815 188.529 98.4804L188.055 99.2346C187.505 100.109 186.151 99.6768 186.21 98.6453L186.483 93.8417C186.492 93.6961 186.468 93.5505 186.414 93.4151L183.601 86.3468C183.261 85.4917 182.043 85.5116 181.731 86.3774Z"
      fill="#237D45"
    />
  </Svg>
);
